export default __webpack_public_path__ + "static/media/developer.7f5680d1.svg";